import { useSchematicBuilderContext } from "../../SchematicBuilderContext";
import { preventDrag } from "../../util/preventDrag";

export function NullableInput() {
  const { schematicKinds, useSchematic, setSchematic } =
    useSchematicBuilderContext();
  const kind = useSchematic((schematic) => schematic.kind);
  const nullable = useSchematic((schematic) => !!schematic.nullable);
  const schematicKind = schematicKinds.get(kind);
  const showInput = schematicKind && schematicKind.nullable === undefined;

  return (
    showInput && (
      <input
        className="builder-input builder-nullable"
        type="checkbox"
        title="Nullable?"
        checked={nullable}
        onChange={(evt) => setSchematic({ nullable: evt.target.checked })}
        {...preventDrag}
      />
    )
  );
}
